module.exports = __webpack_public_path__ + "img/16_RS-junction.a96ec68b.png";